import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NotAuthenticatedError } from 'src/app/seguranca/chronos-http';
import { Logger } from './logger.service';

const log = new Logger('ErrorHandlerInterceptor');

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private messageService: MessageService, private router: Router) {}

  handleError(errorResponse: HttpErrorResponse | any) {
    let msg: string =
      'Desculpe, mas ocorreu um problema inesperado. Estamos trabalhando para resolver isso o mais rápido possível. Por favor, tente novamente mais tarde.';

    if (errorResponse.status === 404) return;

    if (errorResponse instanceof NotAuthenticatedError) {
      msg =
        'Sua sessão expirou! Você será redirecionado para a página de login.';
      this.router.navigate(['/login']);
      return;
    }

    if (errorResponse.status === 401) {
      msg =
        'Sua sessão expirou! Você será redirecionado para a página de login.';
      this.router.navigate(['/login']);
      return;
    }

    msg = errorResponse === 'string' ? errorResponse : msg;

    if (errorResponse instanceof HttpErrorResponse) {
      const extractMessage = this.extrairMessagemError(errorResponse);

      switch (errorResponse.status) {
        case 400:
          msg = extractMessage
            ? extractMessage
            : 'Ocorreu um erro na sua solicitação. Verifique os dados e tente novamente.';
          break;
        case 403:
          msg = extractMessage
            ? extractMessage
            : 'Você não tem permissão para acessar este recurso.';
          break;
      }
    }

    console.error('Erro na requisição', errorResponse);

    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: msg,
      life: 5000,
    });
  }

  private extrairMessagemError(
    errorResponse: HttpErrorResponse
  ): string | undefined {
    let msg: string | undefined;

    try {
      if (errorResponse.error.objects?.length) {
        msg = errorResponse.error.objects
          .map((err: any) => err.userMessage)
          .join('\n');
      } else {
        msg = errorResponse.error?.userMessage ?? errorResponse.error?.detail;
      }
    } catch (e) {
      log.error('Erro ao processar a resposta de erro', e);
    }

    return msg;
  }
}
